export const getStyle = (el, styleProp) => {
  const x = el;
  let y = null;

  if (x.currentStyle) {
    y = x.currentStyle[styleProp];
  } else if (window.getComputedStyle) {
    y = document.defaultView
      .getComputedStyle(x, null)
      .getPropertyValue(styleProp);
  }

  return y;
};
